import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Sidebar, MobileNav } from "./components/Sidebar";
import { Toaster } from "./components/ui/sonner";
import { useLiveStatus } from "./hooks/useLiveStatus";
import { DashboardPage } from "./pages/Dashboard";
import { LogsPage } from "./pages/Logs";
import { SettingsPage } from "./pages/Settings";

/**
 * App-Shell mit BrowserRouter, Sidebar links + Header oben.
 */
export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

function Layout() {
  const { wsState } = useLiveStatus();
  return (
    <div className="canvas-grain relative min-h-screen">
      <Sidebar />
      <div className="md:pl-60">
        <Header wsState={wsState} />
        <MobileNav />
        <main className="px-6 py-8 pb-20 animate-fade-in-up">
          <div className="mx-auto max-w-6xl">
            <Routes>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/logs" element={<LogsPage />} />
            </Routes>
          </div>
        </main>
      </div>
      <Toaster />
    </div>
  );
}
